import { PaletteOptions } from '@mui/material/styles';
import tokens from '@skodaflow/web-tokens/src/tokens.json';
import { paletteLight } from './paletteLight.theme';

const tokenColors = tokens['flow-colors'];

export const paletteDark: PaletteOptions = {
  ...paletteLight,
  mode: 'dark',
  text: {
    ...paletteLight.text,
    // white
    primary: tokenColors['on-surface0'],
    secondary: tokenColors['on-surface200'],
  },
  background: {
    ...paletteLight.background,
    // dark grey
    primary: tokenColors['on-surface900'],
    paper: tokenColors['on-surface900'],
  },
  surface: {
    ...paletteLight.surface,
    primary: '#232425', // os850
    secondary: tokenColors['on-surface600'],
  },
  divider: tokenColors['on-surface600'],
};
paletteDark.transparent.toString = () => 'transparent';
